import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getLinks, createLink, deleteLink } from "../../api/linkApi";
import { uploadImage } from "../../api/imageApi";

const AdminHome = () => {
  const [newsItems, setNewsItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [newNews, setNewNews] = useState({ title: "", url: "", image: "" });
  const category = "Latest News"; // Consistent with other admin files
  const navigate = useNavigate();

  // useEffect(() => {
  //   const fetchNews = async () => {
  //     try {
  //       const links = await getLinks(category);
  //       setNewsItems(links);
  //     } catch (error) {
  //       console.error("Error fetching news:", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   fetchNews();
  // }, []);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const links = await getLinks(category);
  
        // ✅ Sort newest-first
        const sortedLinks = links.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
  
        // ✅ Ensure React updates the UI properly
        setNewsItems([...sortedLinks.map(item => ({ ...item }))]);
      } catch (error) {
        console.error("Error fetching news:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchNews();
  }, []);
  

  const handleCreate = async () => {
    if (!newNews.title || !newNews.url || (!newNews.image && !newNews.file)) {
      alert("All fields are required");
      return;
    }
  
    try {

      let imageUrl = newNews.image;

      // ✅ Handle image file upload if a file is selected
      // if (!newNews.isExternal && newNews.file) {
      //   const formData = new FormData();
      //   formData.append("image", newNews.file);
      //   formData.append("category", category);
      //   formData.append("category", "Latest News");

      if (newNews.file) {
        const formData = new FormData();
        formData.append("image", newNews.file);
        formData.append("title", newNews.title);
        formData.append("category", category);
        

        // 🔍 Debugging: Confirm formData contents
      console.log("📤 Uploading image with formData:");
      for (let [key, value] of formData.entries()) {
        console.log(`   ${key}:`, value);
      }

       // ✅ Debugging: Confirm what FormData holds before sending
  console.log("📝 Checking FormData keys before upload:");
  for (let [key, value] of formData.entries()) {
    console.log(`${key}:`, value);
  }

  console.log("📤 Uploading image...");
  

        // console.log("📤 Uploading image...");
        // console.log("📝 Checking FormData before upload:", [...formData.entries()]);
        // console.log("category before upload:", category);

        const uploadedImage = await uploadImage(formData, category);
        imageUrl = uploadedImage.fileUrl; // ✅ Use the uploaded image URL
      }

      const data = {
        title: newNews.title,
        url: newNews.url,
        // imageUrl: newNews.image, 
        imageUrl,
        category: "Latest News",
        
      };

      console.log("Sending link data:", data);

      // Create new link
      const createdItem = await createLink(data);
      console.log("🟢 Created News Item:", createdItem); 

      // // Fetch updated news list
      // let updatedNews = await getLinks("Latest News");
      // const updatedNews = [...newsItems, createdItem];
      const updatedNews = [createdItem, ...newsItems];
      // Fetch updated news list
    // const updatedNews = await getLinks(category);
    // const updatedNews = await getLinks("Latest News");

      // Sort news by createdAt (oldest first)
      const sortedNews = updatedNews.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

      // If more than 3 items, delete the oldest one
      if (sortedNews.length > 3) {
        // const oldestNewsId = sortedNews[0]._id;
        const oldestNewsId = sortedNews[sortedNews.length - 1]._id;
        await deleteLink(oldestNewsId);
        // sortedNews.shift();
        // sortedNews.pop();
        
      }

      // Update UI with only the last 3 items
      // setNewsItems([...newsItems, createdItem]);
      // setNewsItems(sortedNews.slice(-3));
      setNewsItems(sortedNews.slice(0,3));
      // setNewNews({ title: "", url: "", image: "" });
      // setNewNews({ title: "", url: "", image: "", file: null, isExternal: true });
      setNewNews({ title: "", url: "", image: "", file: null });
    } catch (error) {
      console.error("Error adding news:", error);
    }
  };
  

  const handleDelete = async (id) => {
    try {
      await deleteLink(id);
      setNewsItems(newsItems.filter((item) => item._id !== id));
    } catch (error) {
      console.error("Error deleting news:", error);
    }
  };

  if (loading) return <p>Loading...</p>;

  return (
    <div className="container mx-auto p-6">
      <button
        onClick={() => navigate("/admin")}
        className="bg-gray-300 text-gray-800 px-4 py-2 rounded mb-4 hover:bg-gray-400"
      >
        ← Back to Dashboard
      </button>
      <h1 className="text-3xl font-bold mb-6">Admin - Latest News</h1>

      {/* Add News */}
      <div className="mb-6 p-4 border rounded shadow-md">
        <input
          type="text"
          placeholder="Title"
          value={newNews.title}
          onChange={(e) => setNewNews({ ...newNews, title: e.target.value })}
          className="border p-2 w-full mb-2"
        />

        {/* ✅ Radio Buttons for Image Selection */}
        <div className="mb-2">
          <label className="mr-4">
            <input
              type="radio"
              name="imageType"
              checked={newNews.isExternal}
              onChange={() => setNewNews({ ...newNews, isExternal: true, file: null })}
            />{" "}
            Use Image URL
          </label>
          <label>
            <input
              type="radio"
              name="imageType"
              checked={!newNews.isExternal}
              onChange={() => setNewNews({ ...newNews, isExternal: false, image: "" })}
            />{" "}
            Upload Image
          </label>
        </div>


      {/* ✅ Show URL Input OR File Upload */}
      {newNews.isExternal ? (
          <input
            type="text"
            placeholder="Image URL"
            value={newNews.image}
            onChange={(e) => setNewNews({ ...newNews, image: e.target.value })}
            className="border p-2 w-full mb-2"
          />
        ) : (
          <input
            type="file"
            accept="image/*"
            // onChange={(e) => setNewNews({ ...newNews, file: e.target.files[0] })}
            onChange={(e) => setNewNews({ ...newNews, file: e.target.files[0] })}
            className="border p-2 w-full mb-2"
          />
        )}

        <input
          type="text"
          placeholder="External Link"
          value={newNews.url}
          onChange={(e) => setNewNews({ ...newNews, url: e.target.value })}
          className="border p-2 w-full mb-2"
        />
        <button onClick={handleCreate} className="bg-green-500 text-white px-4 py-2 rounded">
          Add News
        </button>
      </div>

        {/* <input
          type="text"
          placeholder="Image URL"
          value={newNews.image}
          onChange={(e) => setNewNews({ ...newNews, image: e.target.value })}
          className="border p-2 w-full mb-2"
        />
        <input
          type="text"
          placeholder="External Link"
          value={newNews.url}
          onChange={(e) => setNewNews({ ...newNews, url: e.target.value })}
          className="border p-2 w-full mb-2"
        />
        <button onClick={handleCreate} className="bg-green-500 text-white px-4 py-2 rounded">
          Add News
        </button>
      </div> */}

      {/* Display News Items */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {newsItems.map((news) => (
          <div key={news._id} className="border p-4 rounded shadow-md">
            <img src={news.imageUrl} alt={news.title} className="w-full h-40 object-cover rounded" />
            <h3 className="text-lg font-semibold mt-2">{news.title}</h3>
            <a href={news.url} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">
              View Article
            </a>
            <button
              onClick={() => handleDelete(news._id)}
              className="bg-red-500 text-white px-2 py-1 rounded mt-2"
            >
              Delete
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminHome;

